import Immutable from 'immutable'

export const ProductRequirementRecord = Immutable.Record({
  id: null,
  requirement: '',
  realms: Immutable.OrderedSet(), // Only for an 'authentication' requirement
  passwordValidation: '', // only for an 'authentication' requirement
  usernameValidation: '', // only for an 'authentication' requirement
}, 'ProductRequirement')

export default function createProductRequirement({
  realms = [],
  ...data
}) {
  return new ProductRequirementRecord({
    ...data,
    realms: Immutable.OrderedSet(realms),
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/ProductRequirement.js